export default __webpack_public_path__ + "static/media/screenshot16.0b6ad520.jpg";